import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { RequestService } from "../../../requests/request.service";
import { BargainingService } from "../../bargaining.service";

@Component({
  selector: "app-select-bargaining",
  templateUrl: "./select-bargaining.component.html",
  styleUrls: ["./select-bargaining.component.scss"],
})
export class SelectBargainingComponent implements OnInit {
  public requestsList: Array<any> = [];
  public candidateHash: any = "";
  public requestID: any = "";
  public candidateList: any = [];
  public bargainingList: any = [];

  constructor(
    public router: Router,
    public _utilService: UtilsService,
    private requestService: RequestService,
    private bargainingService: BargainingService,
  ) {
    this._utilService.disableAutoHideLoading();
  }

  async ngOnInit() {
    this.requestsList = await this.requestService.getRequestList();
    this.requestsList = this.requestsList.sort((a, b) => (a.id > b.id ? -1 : 1));
    this.requestsList.map((item) => {
      item.title = this.requestService.createRequestTitle(item);
    });
    this.bargainingList = await this.bargainingService.getBargainings(); //Chiamo tutte le contrattazioni
    this.bargainingList = this.bargainingList.filter((item: any) => item.status !== 2);
    this._utilService.hideLoading();
  }

  async changeRequestCandidate() {
    this.candidateHash = "";
    let allStepList = await this.requestService.getSteps(Number(this.requestID));
    allStepList = allStepList.sort((a, b) => (a.insert_date > b.insert_date ? -1 : 1));
    allStepList = allStepList.filter((value, index, self) => index === self.findIndex((t) => t.user_hash === value.user_hash && t.name === value.name));
    this.candidateList = allStepList.filter((item: any) => item.step === 6 && item.user.type_id === 1);
    this.bargainingList.map((item: any) => {
      this.candidateList = this.candidateList.filter((candidate: any) => candidate.user_hash !== item.user_hash && candidate.step);
    });

    this.candidateList = this.candidateList.filter((cand: any) => {
      const foundBargaining: any = this.bargainingList.filter((barg: any) => barg.candidate_id === cand.candidate_id);
      return foundBargaining.length < 1;
    });

    if (this.candidateList.length === 1) {
      this.requestID = this.candidateList[0].request_id;
      this.candidateHash = this.candidateList[0].user_hash;
    }
  }
}
